import { c as _c } from "react/compiler-runtime";
import React from "react";
import { XMarkIcon } from "@heroicons/react/24/outline";
import type { ApiProfileMin } from "@/generated/models/ApiProfileMin";
interface ArtistPreviewModalHeaderProps {
  readonly user: ApiProfileMin;
  readonly onClose: () => void;
  readonly isApp?: boolean | undefined;
  readonly currentContentType: "active" | "winners";
  readonly submissionCount: number;
  readonly winnerCount: number;
}
export const ArtistPreviewModalHeader: React.FC<ArtistPreviewModalHeaderProps> = t0 => {
  const $ = _c(38);
  const {
    user,
    onClose,
    isApp: t1,
    currentContentType,
    submissionCount,
    winnerCount
  } = t0;
  const isApp = t1 === undefined ? false : t1;
  let t2;
  if ($[0] !== currentContentType || $[1] !== user.handle) {
    t2 = () => {
      const artistName = user.handle || "Unknown Artist";
      return currentContentType === "winners" ? `${artistName}'s Won Artworks` : `${artistName}'s Submissions`;
    };
    $[0] = currentContentType;
    $[1] = user.handle;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const getTitle = t2;
  let t3;
  if ($[3] !== currentContentType || $[4] !== submissionCount || $[5] !== winnerCount) {
    t3 = () => {
      const count = currentContentType === "winners" ? winnerCount : submissionCount;
      return `${count} artwork${count !== 1 ? "s" : ""}`;
    };
    $[3] = currentContentType;
    $[4] = submissionCount;
    $[5] = winnerCount;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const getCurrentCount = t3;
  const t4 = `tw-relative tw-z-[100] tw-flex tw-flex-col ${isApp ? "tw-px-6 tw-py-4" : "tw-p-6"} tw-border-b tw-border-iron-800/60 tw-border-solid tw-border-t-0 tw-border-x-0`;
  let t5;
  if ($[7] !== user.pfp) {
    t5 = user.pfp && <img src={user.pfp} alt="Profile" className="tw-w-full tw-h-full tw-object-contain tw-bg-transparent" />;
    $[7] = user.pfp;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t5) {
    t6 = <div className="tw-h-11 tw-w-11 tw-flex-shrink-0 tw-rounded-lg tw-overflow-hidden tw-bg-iron-900 tw-ring-1 tw-ring-white/10">{t5}</div>;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  const t7 = `tw-text-xl sm:tw-text-2xl tw-font-semibold tw-mb-1 tw-tracking-tight tw-transition-all tw-duration-300 ${currentContentType === "winners" ? "tw-text-transparent tw-bg-clip-text tw-bg-gradient-to-r tw-from-amber-100 tw-via-yellow-50 tw-to-amber-100" : "tw-text-iron-100"}`;
  const t8 = getTitle();
  let t9;
  if ($[11] !== t7 || $[12] !== t8) {
    t9 = <div className={t7}>{t8}</div>;
    $[11] = t7;
    $[12] = t8;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  const t10 = getCurrentCount();
  let t11;
  if ($[14] !== t10) {
    t11 = <span>{t10}</span>;
    $[14] = t10;
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  let t12;
  let t13;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <span className="tw-w-1 tw-h-1 tw-rounded-full tw-bg-white/40" />;
    t13 = <span>The Memes Collection</span>;
    $[16] = t12;
    $[17] = t13;
  } else {
    t12 = $[16];
    t13 = $[17];
  }
  let t14;
  if ($[18] !== t11) {
    t14 = <div className="tw-flex tw-items-center tw-gap-2 tw-text-sm tw-transition-colors tw-duration-300 tw-text-white/50">{t11}{t12}{t13}</div>;
    $[18] = t11;
    $[19] = t14;
  } else {
    t14 = $[19];
  }
  let t15;
  if ($[20] !== t14 || $[21] !== t9) {
    t15 = <div className="tw-text-left tw-relative">{t9}{t14}</div>;
    $[20] = t14;
    $[21] = t9;
    $[22] = t15;
  } else {
    t15 = $[22];
  }
  let t16;
  if ($[23] !== t15 || $[24] !== t6) {
    t16 = <div className="tw-flex sm:tw-flex-row tw-flex-col sm:tw-items-center sm:tw-gap-4 tw-gap-3">{t6}{t15}</div>;
    $[23] = t15;
    $[24] = t6;
    $[25] = t16;
  } else {
    t16 = $[25];
  }
  let t17;
  if ($[26] !== isApp || $[27] !== onClose) {
    t17 = !isApp && <button onClick={onClose} className="tw-flex tw-items-center tw-justify-center tw-h-10 tw-w-10 tw-flex-shrink-0 tw-rounded-full tw-bg-iron-950 tw-text-white tw-transition tw-duration-200 tw-border tw-border-solid tw-border-iron-800/70 desktop-hover:hover:tw-border-iron-700 desktop-hover:hover:tw-bg-iron-900 focus:tw-outline-none focus:tw-ring-1 focus:tw-ring-iron-600/70 active:tw-scale-95" aria-label="Close Gallery"><XMarkIcon className="tw-w-5 tw-h-5 tw-flex-shrink-0" /></button>;
    $[26] = isApp;
    $[27] = onClose;
    $[28] = t17;
  } else {
    t17 = $[28];
  }
  let t18;
  if ($[29] !== t16 || $[30] !== t17) {
    t18 = <div className="tw-flex tw-gap-x-3 tw-justify-between">{t16}{t17}</div>;
    $[29] = t16;
    $[30] = t17;
    $[31] = t18;
  } else {
    t18 = $[31];
  }
  let t19;
  if ($[32] !== t18 || $[33] !== t4) {
    t19 = <div className={t4}>{t18}</div>;
    $[32] = t18;
    $[33] = t4;
    $[34] = t19;
  } else {
    t19 = $[34];
  }
  const HeaderInner = t19;
  let t20;
  if ($[35] !== HeaderInner || $[36] !== currentContentType) {
    t20 = currentContentType === "winners" ? <div className="tw-relative tw-overflow-hidden"><div className={"tw-absolute tw-inset-x-0 tw-top-0 tw-h-14 tw-pointer-events-none\n      tw-bg-[linear-gradient(180deg,rgba(234,223,191,0.045),rgba(0,0,0,0)_80%)]"} /><div className={"tw-absolute tw-inset-0 tw-pointer-events-none\n      tw-bg-[linear-gradient(115deg,rgba(234,223,191,0.04)_0%,transparent_40%)]"} /><div className={"tw-absolute tw-inset-0 tw-pointer-events-none\n      tw-bg-[radial-gradient(120%_140%_at_50%_120%,rgba(0,0,0,0.22),transparent_45%)]"} /><div className="tw-absolute tw-inset-x-0 tw-bottom-0 tw-h-px tw-pointer-events-none tw-bg-white/10" />{HeaderInner}</div> : HeaderInner;
    $[35] = HeaderInner;
    $[36] = currentContentType;
    $[37] = t20;
  } else {
    t20 = $[37];
  }
  return t20;
};